
import Vue from 'vue';
import Component from 'vue-class-component';

import AdvertisingActive from './AdvertisingActive.vue';
import AdvertisingInactive from './AdvertisingInactive.vue';
import IncomeAdvertising from './IncomeAdvertising.vue';

@Component({
  components: {
    AdvertisingActive,
    AdvertisingInactive,
    IncomeAdvertising
  },
})
export default class AdvertisingList extends Vue {

  /* INITIALIZATION */

  private isActive: boolean = true;
  private activeTab:number = 0
  private tabs = [
    {
      text: "active",
      href: "#"
    },
    {
      text: "inactive",
      href: "#"
    },
    {
      text: "advertising_revenue",
      href: "#"
    }
  ]

  constructor() {
    super();
  }

  private created() {
    if(this.$route.query.t) this.activeTab = Number(this.$route.query.t)
    
  }
}
